import { format, getTime, formatDistanceToNow } from 'date-fns';
import moment from 'moment-timezone';

let regionalFormats = { dateFormat: 'DD/MM/YYYY', timeFormat: 'HH:mm', timezone: moment.tz.guess() };

export function setDateTimeFormats(settings = {}) {
  regionalFormats = { ...regionalFormats, ...settings };
}

export function getDateTimePickerConfig(settings = regionalFormats) {
  const dateFormat = settings.dateTimeFormats?.date || 'dd/MM/yyyy';
  const timeFormat = settings.dateTimeFormats?.time || 'HH:mm';
  return {
    ampm: settings.dateTimeFormats?.ampm ?? false,
    formats: {
      keyboardDate: dateFormat,
      keyboardDateTime: `${dateFormat} ${timeFormat}`,
      keyboardDateTime12h: `${dateFormat} ${timeFormat}`,
      keyboardDateTime24h: `${dateFormat} ${timeFormat}`,
      fullTime: timeFormat,
      fullTime12h: timeFormat,
      fullTime24h: timeFormat,
    },
  };
}

// ----------------------------------------------------------------------

export function fDate(date, newFormat) {
  if (!newFormat) return date ? moment(date).tz(regionalFormats.timezone).format(regionalFormats.dateFormat) : '';
  return date ? format(new Date(date), newFormat) : '';
}

export function fDateTime(date, newFormat) {
  if (!newFormat) return date ? moment(date).tz(regionalFormats.timezone).format(`${regionalFormats.dateFormat} ${regionalFormats.timeFormat}`) : '';
  return date ? format(new Date(date), newFormat) : '';
}

export function fTime(date, newFormat) {
  if (!newFormat) return date ? moment(date).tz(regionalFormats.timezone).format(regionalFormats.timeFormat) : '';
  return date ? format(new Date(date), newFormat) : '';
}

export function fTimestamp(date) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : '';
}


export function fCurrentDateTime() {
  return format(new Date(), "yyyy-MM-dd HH:mm:ss.SSS");
}
export function formatHourMinute(date) {
  let dateObj = new Date(date)
  const hour = String(dateObj.getHours()).padStart(2, "0");
  const minutes = String(dateObj.getMinutes()).padStart(2, "0");
  return `${hour}:${minutes}`;
}
